import { ORGANIZATION_ROLE, VALID_ORGANIZATION_ROLES } from '../../settings.const'
import type { OrganizationRole } from '../../settings.interface'

// TODO: WorkspaceService.getOrganizationsByUserId does not expose membership role yet.
export function normalizeOrganizationRole(role: OrganizationRole): OrganizationRole {
  return VALID_ORGANIZATION_ROLES.includes(role) ? role : ORGANIZATION_ROLE.OWNER
}
